import qs from 'qs';

import { URL } from '@api/urls';

import { IMavenirConfigUploadUrl } from '@interfaces/cmModule/dataSources';
import { TCMDatesMavenirDatesDTO, TCMSitesIdsDTO } from '@interfaces/cmModule/dto/cmModuleDTO';
import {
	IGoldenSettingsOnSelectedDateDTO,
	TGoldenSettingsConfigTreeDTO,
	TGoldenSettingsImportDTO,
	TGoldenSettingsOptionDTO,
	TGoldenSettingsSetTypeDTO,
	TGoldenSettingsValidationRulesDTO,
} from '@interfaces/cmModule/dto/goldenSettingsDTO';
import {
	IGoldenSettingsConfigData,
	IGoldenSettingsInfo,
	IGoldenSettingsTree,
	IGoldenSettingsValidationRules,
} from '@interfaces/cmModule/goldenSettings';
import { IDefaultUploadUrlApi } from '@interfaces/common/file';
import { IDefaultExportResponse } from '@interfaces/common/response';

import { client } from './client';

const {
	goldenSettings,
	goldenSettingsInfo,
	goldenSettingsConfig,
	goldenSettingsConfigTree,
	goldenSettingsValidationRules,
	goldenSettingsOptionsDates,
	goldenSettingsCreateUploadUrl,
	goldenSettingsReset,
	goldenSettingsDates,
	goldenSettingsSites,
	goldenSettingsExport,
	goldenSettingsImport,
} = URL;

export const getGoldenSettingsConfig = (params: TGoldenSettingsOptionDTO): Promise<IGoldenSettingsConfigData> => {
	return client.get(goldenSettings, {
		params,
		paramsSerializer: params => qs.stringify(params, { indices: false }),
	});
};

export const getGoldenSettingsMavenirConfigTree = (
	dto: TGoldenSettingsConfigTreeDTO,
): Promise<IGoldenSettingsTree> => {
	return client.post(goldenSettingsConfigTree, dto);
};

export const getGoldenSettingsOnSelectedDate = (dto: IGoldenSettingsOnSelectedDateDTO): Promise<string> => {
	return client.post(goldenSettingsConfig, dto);
};

export const getGoldenSettingsInfo = (params: TGoldenSettingsOptionDTO): Promise<IGoldenSettingsInfo> => {
	return client.get(goldenSettingsInfo, {
		params,
		paramsSerializer: params => qs.stringify(params, { indices: false }),
	});
};

export const getGoldenSettingsValidationRules = (
	dto: TGoldenSettingsValidationRulesDTO,
): Promise<IGoldenSettingsValidationRules[]> => {
	return client.post(goldenSettingsValidationRules, dto);
};

export const setGoldenSettings = (dto: TGoldenSettingsSetTypeDTO): Promise<void> => {
	return client.post(goldenSettings, dto);
};

export const editGoldenSettings = ({
	id,
	...dto
}: TGoldenSettingsSetTypeDTO): Promise<void> => {
	return client.post(`${goldenSettings}/${id}`, dto);
};

export const resetGoldenSettings = (params: TGoldenSettingsOptionDTO): Promise<void> => {
	return client.post(goldenSettingsReset, undefined, {
		params,
		paramsSerializer: params => qs.stringify(params, { indices: false }),
	});
};

export const getGoldenSettingsDates = (dto: TCMDatesMavenirDatesDTO): Promise<number[]> => {
	return client.post(goldenSettingsDates, dto);
};

export const getGoldenSettingsDatesMavenir = (dto: TCMSitesIdsDTO): Promise<string[]> => {
	return client.post(goldenSettingsOptionsDates, dto);
};

export const getGoldenSettingsSites = (params: TCMSitesIdsDTO): Promise<string[]> => {
	return client.get(goldenSettingsSites, { params });
};

export const getGoldenSettingsExport = (params: TGoldenSettingsOptionDTO): Promise<void> => {
	return client.post(goldenSettingsExport, null, {
		params,
		paramsSerializer: params => qs.stringify(params, { indices: false }),
	});
};

export const createUploadUrlGoldenSettings = (dto: IDefaultUploadUrlApi): Promise<IMavenirConfigUploadUrl> => {
	return client.post(goldenSettingsCreateUploadUrl, dto);
};

export const executeGoldenSettingsImport = (dto: TGoldenSettingsImportDTO): Promise<IDefaultExportResponse> => {
	return client.post(`${goldenSettingsImport}/${dto.importId}/execute`, dto);
};
